__webpack_require__.p = "https://wayak-resource.wenext.media/h5-prod/h5-greedy/";